import { render, staticRenderFns } from "./ModalCancellation.vue?vue&type=template&id=1621c3ec&"
import script from "./ModalCancellation.vue?vue&type=script&lang=js&"
export * from "./ModalCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports